import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'

import { LOCALE_PREFIX } from '../../constants'

import './style.scss'

export default class TooltipContent extends Component {
    render() {
        return (
            <div className={'signals-tooltip'}>
                <FormattedMessage id={`${LOCALE_PREFIX}.tooltip.header`} values={{ p: (chunks) => <p>{chunks}</p> }} />
                <FormattedMessage
                    id={`${LOCALE_PREFIX}.tooltip.risk`}
                    values={{ p: (chunks) => <p className={'type-risk'}>{chunks}</p> }}
                />
                <FormattedMessage
                    id={`${LOCALE_PREFIX}.tooltip.caution`}
                    values={{ p: (chunks) => <p className={'type-caution'}>{chunks}</p> }}
                />
                <FormattedMessage
                    id={`${LOCALE_PREFIX}.tooltip.info`}
                    values={{ p: (chunks) => <p className={'type-notice'}>{chunks}</p> }}
                />
                <FormattedMessage
                    id={`${LOCALE_PREFIX}.tooltip.text`}
                    values={{ p: (chunks) => <p>{chunks}</p>, br: <br /> }}
                />
            </div>
        )
    }
}
